<script setup>
import { defineProps, defineEmits } from 'vue';

const emit = defineEmits(['close']);
const { data, index } = defineProps(['data', 'index']);

const { confirmCallback, confirmText } = data;

const fnPushNativeSetting = () => {
  if (confirmCallback) confirmCallback();
  emit('close', index);
};
</script>

<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal_type02">
          <div class="modal-con">
            <div class="modal-txt">
              <p>
                {{ $t('modal.native_alert_state.notice') }}
              </p>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn yd-cta yd-cta--primary" @click="fnPushNativeSetting()">{{ confirmText }}</button>
              <button class="btn bo yd-cta yd-cta--secondary" @click="emit('close', index)">close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
